<div
  class="tasks-container"
  [class.side-drawer]="sideDrawerConfiguration"
>
  <mojo-collection [overflowHidden]="false">
    <mat-accordion class="expantion-transition">
      <mat-expansion-panel
        *ngIf="(tasks$ | async) as tasks"
        class="mat-expantion-tpanel"
        [ngClass]="{'task': (isAssignOpened && !tasks?.length ) || (fromTalentPool && isAssignOpened &&  !tasks?.length )}"
        [expanded]="true"
        (opened)="isPanelOpen = true"
        (closed)="isPanelOpen = false"
        [disabled]="sideDrawerConfiguration"
      >
        <mat-expansion-panel-header class="main-container-expands">
          <div
            class="header"
            [ngClass]="{'padding-info': (isPanelOpen && !sideDrawerConfiguration), 'padding-info-side-drawer': sideDrawerConfiguration}"
          >
            <div class="d-flex">
              <div
                *ngIf="isExpandible"
                (click)="toggleCard()"
                class="expand-button"
                color="light-natural"
              >

                <mat-icon
                  *ngIf="!isPanelOpen"
                  class="rotate-arrow color-arrow-expandable font-s-icon mat-icon-right"
                >
                  arrow_drop_up
                </mat-icon>
                <mat-icon
                  *ngIf="isPanelOpen"
                  class="color-arrow-expandable font-s-icon mat-icon-top"
                >
                  arrow_drop_down
                </mat-icon>
              </div>
              <h2
                class="task-title"
                (click)="$event.stopPropagation()"
              >Tasks</h2>
            </div>

            <div
              (click)="$event.stopPropagation()"
              class="buttons-container"
              *ngIf="isPanelOpen"
            >
              <span
                (click)="addTask($event)"
                class="add-task-button"
              >+Add task</span>
            </div>
          </div>
        </mat-expansion-panel-header>
        <div
          class="body"
          *ngIf="tasks; else loader"
        >
          <mojo-tasks-list
            (emiterScroll)="onScroll($event)"
            [tasks]="tasks"
            [totalPages]="totalTasksPages$ | async"
            [sideDrawerConfiguration]="sideDrawerConfiguration"
            (taskCreated)="createTask($event)"
            (isAssignOpened)="setIsAssignOpened($event)"
            [width]="width"
          >
          </mojo-tasks-list>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mojo-collection>
</div>
<div
  *ngIf="showLine && !(isMobileView$ | async)"
  class="padding-line"
>
  <div class="line-ln"></div>
</div>

<ng-template #loader>
  <mojo-loader></mojo-loader>
</ng-template>
